import { NavLink } from "react-router-dom";

// Change this if your dashboard lives at a different path (e.g. "/admin/dashboard")
const DASHBOARD_PATH = "/admin";

export default function AdminNav() {
  return (
    <nav className="adm-nav" aria-label="Admin sections">
      <NavLink to={DASHBOARD_PATH} end>Dashboard</NavLink>
      <NavLink to="/admin/products">Products</NavLink>
      <NavLink to="/admin/orders">Orders</NavLink>
    </nav>
  );
}